import { render, staticRenderFns } from "./related-tickets.vue?vue&type=template&id=e3b513ee&scoped=true&"
import script from "./related-tickets.vue?vue&type=script&lang=js&"
export * from "./related-tickets.vue?vue&type=script&lang=js&"
import style0 from "./related-tickets.vue?vue&type=style&index=0&id=e3b513ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b513ee",
  null
  
)

export default component.exports